import { useEffect } from 'react';
import useFetchDownloads from '../queries/downloads/useFetchDownloads';
import useFetchDownloadResource from '../queries/downloads/useFetchDownloadResource';
import useSubscribeStorage from '../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';

const EntityManager = ({ children }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);
  const downloadResourcesQuery = useFetchDownloads({ customerEnvId });
  const { mutate: updateDownloadResource } = useFetchDownloadResource({
    customerEnvId,
  });

  useEffect(() => {
    if (!downloadResourcesQuery?.data) return;
    const pendingResources = downloadResourcesQuery?.data.filter(
      resource => resource.status === 'pending',
    );

    pendingResources.forEach(resource => {
      updateDownloadResource({ downloadId: resource.id });
    });

    const intervalId = setInterval(() => {
      pendingResources.forEach(resource => {
        updateDownloadResource({ downloadId: resource.id });
      });
    }, 10000);

    if (intervalId && !pendingResources.length) {
      clearInterval(intervalId);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [updateDownloadResource, downloadResourcesQuery?.data]);

  return <>{children}</>;
};

export default EntityManager;
